import { render, staticRenderFns } from "./Userbar.vue?vue&type=template&id=67b9a71a"
import script from "./Userbar.vue?vue&type=script&lang=js"
export * from "./Userbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports